module.exports = __webpack_public_path__ + "media/metronic/_theme/media/error/bg2-45c96894b7392202f1e7f1225b978e72.jpg";